import {
  PREGNANT_AND_NEWBORN_ABOUT_CHILD_STEP,
  PREGNANT_AND_NEWBORN_ABOUT_YOU_STEP,
  PREGNANT_AND_NEWBORN_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/LifeProducts/PregnantAndNewborn";

import { BooleanFormType } from "Store/interfaces/FormTypes";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { nullableBooleanToNullableFormBoolean } from "Utils/formUtils";
import { parse } from "date-fns";

export function mapFromCommercePregnantAndNewborn(data: {
  [key: string]: any;
}): FormStates {
  const { pregnant, multipleChildren, childBirthDate, coverageGroup } = data;
  const isStayingInNorwayForMoreThanFiveYears =
    nullableBooleanToNullableFormBoolean(
      data.isStayingInNorwayForMoreThanFiveYears,
    );
  const isScandinavianCitizen =
    isStayingInNorwayForMoreThanFiveYears === BooleanFormType.TRUE
      ? BooleanFormType.FALSE
      : BooleanFormType.TRUE;

  return {
    [PREGNANT_AND_NEWBORN_ABOUT_YOU_STEP.id]: {
      parentGuardian: BooleanFormType.TRUE,
      isScandinavianCitizen,
      isStayingInNorwayForMoreThanFiveYears,
      pep: BooleanFormType.FALSE,
    },
    [PREGNANT_AND_NEWBORN_ABOUT_CHILD_STEP.id]: {
      childBorn: nullableBooleanToNullableFormBoolean(!pregnant),
      multipleChildren: nullableBooleanToNullableFormBoolean(multipleChildren),
      birthDate: parse(childBirthDate, "yyyy-MM-dd", new Date()),
    },
    [PREGNANT_AND_NEWBORN_PRICE_STEP.id]: {
      coverage: coverageGroup,
    },
  };
}
